import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ProfilesComp } from './profiles';
import { GetProfileList } from '../../models/profile';
import { pnkstore } from '../../stores/pnk-store';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUserStore } from '../../stores/user-store';

export const Profiles = () => {
    const userData = useUserStore;
    const [getProfileList, setGetProfilesList] = useState(false);
    const [profileList, setProfilesList] = useState([{ 'name': 'Ausi', 'number': '8887757415', 'role': 'Agent', 'reports': 'Test Profile', 'added_on': '2025-03-04 12:55:52' }, { 'name': 'Ahmad', 'number': '8887757412', 'role': 'Agent', 'reports': 'Test Profile', 'added_on': '2025-03-04 12:55:52' }, { 'name': 'Test Profile', 'number': '9999999999', 'role': 'Admin', 'reports': 'Admin', 'added_on': '2025-03-04 12:55:52' }]);
    const [searchObj, setSearchObj] = useState({});
    const [alertBox, setAlertBox] = useState(false);
    const [setNo, setSetNo] = useState(1);
    const [perSet, setPerSet] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const navigate = useNavigate();


    const state = {
        getProfileList: getProfileList,
        profileList: profileList,
        loginUserProfile: userData.getState().profile,
        totalRecords: totalRecords,
        perSet: perSet,
        setNo: setNo,
    }



    useEffect(() => {

        setSearchObj({
            'set_no': setNo,
            'per_set': perSet,
        })

        setGetProfilesList(true);

    }, []);

    const HandleChangePage = (event, page) => {
        let set_no = setNo;
        if (event.currentTarget.title == 'Go to next page') {
            set_no = set_no + 1;
        }
        else {
            set_no = set_no - 1;
        }
        setSetNo(set_no);
        setSearchObj((prev) => ({ ...prev, ['set_no']: set_no }));
        setGetProfilesList(true);
    };

    const HandleChangeRowsPerPage = (event) => {
        let value = event.target.value;
        console.log(event.target.value);
        setPerSet(value);
        setSetNo(1);
        setSearchObj((prev) => ({ ...prev, ['set_no']: 1 }));
        setSearchObj((prev) => ({ ...prev, ['per_set']: value }));
        setGetProfilesList(true);

    };

    const ResetPagination = () => {
        setSetNo(1);
        setPerSet(10);
        setSearchObj((prev) => ({ ...prev, ['set_no']: 1 }));
        setSearchObj((prev) => ({ ...prev, ['per_set']: 10 }));
    }


    const HandleInputs = (e, name) => {
        let value = e.target.value;
    }

    const HandleCloseAlert = (type) => {
        if (type == 'No') {
            setAlertBox(false);
        }
        else {

            // setDeleteProfile(true);
            //  setAlertBox(false)
        }
    }


    const HandleGetProfilesListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let profileListData = res.data.profilelistresponse.rows
            setProfilesList(profileListData);
            setTotalRecords(res.data.profilelistresponse.metarow.totalRecordsInDb);
        }
        else {
            setProfilesList([]);
            setTotalRecords(0);
        }
        setGetProfilesList(false);
    }



    const NavigateTo = (route) => {
        navigate('/' + route, {});
    }

    const DeleteProfile = (profile_name) => {
        // setAlertBox(true)
        // setProfileName(profile_name);
    }



    const GetProfileDetails = (profile_id) => {
        NavigateTo('profile/' + profile_id)
    }


    return (
        <Box>
            <ProfilesComp HandleChangePage={HandleChangePage} HandleChangeRowsPerPage={HandleChangeRowsPerPage} profileList={profileList} mystate={state} HandleInputs={HandleInputs} HandleCloseAlert={HandleCloseAlert} NavigateTo={NavigateTo} DeleteProfile={DeleteProfile} GetProfileDetails={GetProfileDetails} />
            {((getProfileList === true) ? GetProfileList(pnkstore, searchObj, userData.getState().token, HandleGetProfilesListSuccessResponse) : '')}
        </Box>
    )
}